'use client';

import type { User } from '@/app/types/User';
import type { Team, TeamPreferences } from '@/services/teams.service';

export interface UserBootstrap {
  userDetails: User;
  userTeams: Team[];
  teamPreferences: TeamPreferences | null;
}

/**
 * Browser-proxy request for the shell's identity/team state. Keeping this
 * client-side avoids a sequence of server-action POSTs during navigation.
 */
export async function getUserBootstrap(): Promise<UserBootstrap> {
  const response = await fetch('/api/v1/users/me/bootstrap');
  if (!response.ok) {
    throw new Error(`Failed to load user bootstrap (${response.status})`);
  }
  return response.json();
}
